/* requires:
polyfill.js
cart.js
*/

const cartSummary = {
  cartWidgetContainer: document.querySelector('#cart-widget-container'),
  cartWidget: null,
  cartDetailsContainer: null,
  focusedQtyId: null, // focused QTY field id before the cart widget is rerendered
  bulkRateModal: document.querySelector('#cart-widget-bulk-rate-modal'),
  bulkModal: null,
  bulkRatesShown: false, // flag to check if the bulk rates modal is showing from the cart widget

  init: () => {
    cartSummary.cartWidget = cartSummary.cartWidgetContainer
      ? cartSummary.cartWidgetContainer.querySelector('.cart-widget')
      : null;
    cartSummary.cartDetailsContainer = cartSummary.cartWidgetContainer
      ? cartSummary.cartWidgetContainer.querySelector('.cart-summary')
      : null;

    cartSummary.bulkModal = new bootstrap.Modal(cartSummary.bulkRateModal);
    cartSummary.bulkRateModal.addEventListener('hidden.bs.modal', () => {
      cartSummary.bulkRatesShown = false;
    });

    // cartSummary.cartWidget.addEventListener('transitionend', () => {
    //   if (cartSummary.cartWidget.checkVisibility({ opacityProperty: true })) {
    //     cartSummary.cartWidgetContainer.classList.add('show');
    //   } else {
    //     cartSummary.cartWidgetContainer.classList.remove('show');
    //   }
    // });
  },

  render: (localCart) => {
    const cartProducts = localCart ? localCart.cartProducts : [];

    cartSummary.cartDetailsContainer.innerHTML = '';

    if (cartProducts.length > 0) {
      // display all product in the cart
      cartProducts
        .reverse()
        .forEach((product) => cartSummary.cartDetailsContainer.appendChild(cartSummary.cartItem(product)));

      // render the cart total and discount section
      cartSummary.cartDetailsContainer.insertAdjacentHTML('beforeend', cartSummary.cartTotalAndDiscount(cartProducts));
    } else {
      const emptyCart = `<li class="list-group-item d-block fs-6 text-center pt-3 border-0 pb-0">
                    Your shopping cart is empty.<br>
                    <button class="btn btn-outline-secondary btn-sm hide-cart-widget d-inline-block mt-3 px-4" type="button">Continue Shopping</button>
                  </li>`;

      cartSummary.cartDetailsContainer.innerHTML = emptyCart;
    }
  },

  // template for a cart item
  cartItem: (product) => {
    const replaceUpsells = product.upSellProducts
      .filter((upsell) => upsell.upsellSectionId === 1 && upsell.isSelected)
      .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

    const accessoryUpsells = product.upSellProducts
      .filter((upsell) => upsell.upsellSectionId === 2 && upsell.isSelected)
      .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

    const digitalUpsells = product.upSellProducts
      .filter((upsell) => upsell.upsellSectionId === 3 && upsell.isSelected)
      .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

    const shippingUpsells = product.upSellProducts
      .filter((upsell) => upsell.upsellSectionId === 4 && upsell.isSelected)
      .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

    const relatedUpsells = product.upSellProducts
      .filter((upsell) => upsell.upsellSectionId === 5 && upsell.isSelected)
      .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

    const selectedUpsells = [
      ...replaceUpsells,
      ...accessoryUpsells,
      ...digitalUpsells,
      ...shippingUpsells,
      ...relatedUpsells,
    ];

    // includeFeesInPrice() is from the file /global/js/include-fees-in-price.js in the CDN
    const showFees = includeFeesInPrice(product.productId) && !product.hiddenFee && product.unitThirdPartyFee > 0;
    const itemDispayPrice = cartSummary.getDisplayPrice(product) * product.quantity;

    const state = {
      // isUpdating: false,
      quantity: product.quantity,
    };

    const cartItemHtml = `
      <li class="list-group-item cart-item d-block px-0" data-product-id="${product.productId}" key="${product.productId}">

        <div class="cart-item-detials d-flex fw-600 lh-14 py-1">
          <div class="item-name">
            ${product.name}
          </div>
          <div class="item-amount text-end">
            ${cartSummary.formatCurrency(itemDispayPrice)}
          </div>
        </div>

        ${
          selectedUpsells.length > 0 || showFees
            ? `<ul class="cart-item-upsell list-group-flush bg-transparent ps-2 m-0 mt-1 mb-2">` +
              `${
                showFees
                  ? `<li class="list-group-item border-0 lh-14 p-0 mb-1">
                    <div class="item-name">
                      ${product.thirdPartyFeeName}
                    </div>
                    <div class="item-amount text-end">
                      ${cartSummary.formatCurrency(product.unitThirdPartyFee * product.quantity)}
                    </div>
                  </li>`
                  : ''
              }` +
              selectedUpsells
                .map(
                  (upsell) => `
                    <li class="list-group-item border-0 lh-14 p-0 mb-1" data-product-id="${upsell.productId}">
                      <div class="item-name">
                        ${upsell.name}
                      </div>
                      <div class="item-amount text-end">
                        ${
                          upsell.upsellType === 'Replace'
                            ? 'Included'
                            : cartSummary.formatCurrency(cartSummary.getDisplayPrice(upsell, true) * product.quantity)
                        }
                      </div>
                    </li>
                  `
                )
                .join('') +
              `</ul>`
            : ''
        }   

        <div class="cart-item-action d-flex align-items-center justify-content-between py-1">
          <div class="cart-item-qty d-flex align-items-center">
            <div class="input-group me-3 notranslate">
              ${
                state.quantity === 1
                  ? `
                  <button class="qty-btn delete-btn btn btn-sm btn-light p-1 pt-0" ${
                    state.quantity === 0 ? 'disabled' : ''
                  } name="decrement" type="button" aria-label="Delete">
                    <svg class="delete-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 -960 960 960" fill="currentColor"><path d="M312-144q-29.7 0-50.85-21.15Q240-186.3 240-216v-480h-48v-72h192v-48h192v48h192v72h-48v479.57Q720-186 698.85-165T648-144H312Zm336-552H312v480h336v-480ZM384-288h72v-336h-72v336Zm120 0h72v-336h-72v336ZM312-696v480-480Z"/></svg>
                  </button>
                `
                  : `
                  <button class="qty-btn btn btn-sm btn-light" ${
                    state.quantity === 0 ? 'disabled' : ''
                  } name="decrement" type="button" aria-label="Decrement">−</button>
                `
              }
              <label class="visually-hidden" for="qty-${product.productId}">Quantity</label>
              <input aria-label="Item Quantity" class="qty-input form-control" id="qty-${
                product.productId
              }" min="1" name="quantity" type=
              "number" value="${state.quantity}" aria-label="Item Quantity">
              <button class="qty-btn btn btn-sm btn-light" name="increment" type="button" aria-label="Increment">+</button>
            </div>
            ${
              product.cartProductBulkTiers && product.cartProductBulkTiers.length > 0
                ? `
                  <div class="bulk-discount-toggle d-inline-block text-muted lh-1">
                    <button class="btn-toggle fw-400 small text-reset lh-1 p-0" type="button" onclick="cartSummary.showBulkRates('${product.productId}')">Bulk Rates<span class="info-icon align-middle">?</span></button>
                  </div>
                `
                : ''
            }
          </div>
          <div class="text-end text-muted">
            <button class="delete-btn btn text-muted" name="delete" type="button" aria-label="Delete Item" onclick="cartSummary.removeFromCart('${
              product.productId
            }')">
              <svg class="delete-icon" xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 -960 960 960" fill="currentColor"><path d="M312-144q-29.7 0-50.85-21.15Q240-186.3 240-216v-480h-48v-72h192v-48h192v48h192v72h-48v479.57Q720-186 698.85-165T648-144H312Zm336-552H312v480h336v-480ZM384-288h72v-336h-72v336Zm120 0h72v-336h-72v336ZM312-696v480-480Z"/></svg>
            </button>
          </div>
        </div>

      </li>
    `;

    const template = document.createElement('template');
    template.innerHTML = cartItemHtml.trim(); // .trim() avoids unwanted whitespace
    const component = template.content.firstElementChild;

    let qtyDebounce;

    // cartSummary.handleQtyChange(event, component, product, state);

    const qtyInput = component.querySelector('[name="quantity"]');
    const incrementBtn = component.querySelector('[name="increment"]');
    const decrementBtn = component.querySelector('[name="decrement"]');

    const handleQtyChange = (event) => {
      // console.log(event);
      const eventType = event.type;
      const { name, value, type, checked } = event.target;
      const theValue = type === 'checkbox' ? checked : value;
      let quantity = state.quantity;

      // const toggleIsInvalid = (isInvalid) => {
      //   if (!isInvalid) {
      //     qtyInput.classList.add('is-invalid');
      //   } else {
      //     qtyInput.classList.remove('is-invalid');
      //   }
      // };

      if (name === 'quantity') {
        if (!isNaN(Number(theValue)) && theValue !== '') {
          quantity = Number(theValue);
          // toggleIsInvalid(Number(theValue) > 0);
        }
        // set the quantity to 1 if the value is empty or not a number
        else if (eventType === 'blur' && theValue === '') {
          qtyInput.value = state.quantity;
        }
      }
      if (name === 'decrement' && quantity > 0) {
        quantity = state.quantity - 1;
      }
      if (name === 'increment') {
        quantity = state.quantity + 1;
      }

      // enabling/disabling the decrement button
      decrementBtn.disabled = quantity === 0 ? true : false;

      // simple debouncing to prevent unecessary API calls when a user continues to change quantity
      // let qtyDebounce;

      if (state.quantity !== quantity) {
        state.quantity = quantity;
        // update the quantity display
        qtyInput.value = state.quantity;

        clearTimeout(qtyDebounce);
        qtyDebounce = setTimeout(() => {
          // showing updating state of the cart widget
          cartSummary.cartWidget.classList.add('is-updating');

          if (document.activeElement.classList.contains('qty-input')) {
            cartSummary.focusedQtyId = document.activeElement.id;
          }

          // if the quantity greater than 0, update the cart
          if (quantity > 0) {
            // update the cart with the new quantity
            cart.updateCart({ productId: product.productId, quantity }, () => {
              cartSummary.show();

              // update bulk order page if the page is the bulk order page
              const bulkOrderTable = document.querySelector('#bulk-table');
              if (bulkOrderTable) {
                bulkOrder.init(false);
              }
            });
          }

          // if the quantity is 0, remove the item from the cart
          else if (quantity === 0) {
            cartSummary.removeFromCart(product.productId);
          }
        }, 300);
      }
    };

    // preventing non-number entry for the qty field
    const handleKeyDown = (event) => {
      const allowedKeys = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        'Delete',
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Enter',
      ];
      if (!allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    };

    qtyInput.addEventListener('keydown', handleKeyDown);
    qtyInput.addEventListener('blur', handleQtyChange);
    qtyInput.addEventListener('input', handleQtyChange);
    incrementBtn.addEventListener('click', handleQtyChange);
    decrementBtn.addEventListener('click', handleQtyChange);

    return component;
  },

  // helper function to render the cart total and discount section
  cartTotalAndDiscount: (cartProducts) => {
    // helper function to get the selected upsells total for a product
    // this needs to be maintained in sync with the cart application's helper function
    const getUpsellTotal = (upsells) => {
      // we are excluding any selected replace upsell from the calculations
      // when an upsellType=Replace upsell is marked as selected it means that the main product is itself
      // this also means that the replace upsell price is alreday included in the main item's price
      return upsells
        .filter((upsell) => upsell.isSelected && upsell.upsellType !== 'Replace')
        .reduce((acc, cur) => {
          return acc + (cur.listPrice + cur.unitThirdPartyFee - cur.combinedDiscount) * cur.quantity;
        }, 0);
    };

    const subTotal = () =>
      cartProducts?.reduce((acc, cur) => {
        const upsellTotal = getUpsellTotal(cur.upSellProducts);
        if (includeFeesInPrice(cur.productId)) {
          return acc + cur.unitPriceWithDiscountAndFee * cur.quantity + upsellTotal;
        }
        return acc + cur.unitPriceWithDiscountAndFeeIfHidden * cur.quantity + upsellTotal;
      }, 0);

    const savings = () =>
      cartProducts?.reduce((acc, cur) => {
        const upsellSavingsTotal = cur.upSellProducts
          .filter((item) => item.isSelected)
          .reduce((acc2, cur2) => {
            return acc2 + cur2.combinedDiscount * cur2.quantity;
          }, 0);
        return acc + upsellSavingsTotal + cur.combinedDiscount * cur.quantity;
      }, 0);

    const appliedCoupons = () => {
      const coupons = [];

      cartProducts?.forEach((item) => {
        const isCouponApplied = item.discountSource === 'Coupon' && item.combinedDiscount > 0;

        if (isCouponApplied) {
          coupons.push(item.discountCode);
        }

        item.upSellProducts
          .filter((item) => item.isSelected)
          .forEach((upsell) => {
            const isCouponApplied = upsell.discountSource === 'Coupon' && upsell.combinedDiscount > 0;

            if (isCouponApplied) {
              coupons.push(upsell.discountCode);
            }
          });
      });

      return [...new Set(coupons)].length ? [...new Set(coupons)].join(', ') : null;
    };

    return `  
      ${
        cartProducts.length > 0
          ? `<li class="list-group-item total fw-700 fs-6 px-0">
              <div class="item-details">
                Total
              </div>
              <div class="item-amount text-end">
                ${cartSummary.formatCurrency(subTotal())}
              </div>
            </li>`
          : ''
      }    
      ${
        savings() > 0
          ? `<li class="list-group-item savings-display">
              <div class="item-details fw-700 text-success">
                You Save
                ${appliedCoupons() ? `<div class="coupon-display fw-400">Coupon: ${appliedCoupons()}</div>` : ''}
              </div>
              <div class="item-amount text-end fw-700 text-success">
                ${cartSummary.formatCurrency(savings())}
              </div>
            </li>`
          : ''
      }   
    `;
  },

  renderCartlink: (localCart) => {
    const cartFooter = cartSummary.cartWidgetContainer.querySelector('.card-footer');

    if (!localCart.cartId || localCart.cartProducts.length === 0) {
      cartFooter.classList.add('d-none');
    } else {
      cartFooter.classList.remove('d-none');
    }
  },

  // Show the cart widget with the current cart data
  show: () => {
    if (!cartSummary.cartWidget) return;

    // get cart data from sessionStorage using cart.js
    const localCart = cart.getLocalCart();

    // render the cart items in the widget
    cartSummary.render(localCart);
    cartSummary.renderCartlink(localCart);

    // if the focusedQty is set and the element is still in the DOM, focus it
    if (cartSummary.focusedQtyId && document.getElementById(cartSummary.focusedQtyId)) {
      document.getElementById(cartSummary.focusedQtyId).focus();
      cartSummary.focusedQtyId = null;
    }

    // cartSummary.cartWidgetContainer.classList.add('show');
    cartSummary.cartWidget.classList.add('show');

    // removing updating state of the cart widget
    cartSummary.cartWidget.classList.remove('is-updating');
  },

  hide: () => {
    cartSummary.cartWidget.classList.remove('show');
    // cartSummary.cartWidgetContainer.classList.remove('show');

    cartSummary.focusedQtyId = null;
  },

  removeFromCart: (productId) => {
    // showing updating state of the cart widget
    cartSummary.cartWidget.classList.add('is-updating');

    cart.removeFromCart(productId, () => {
      cartSummary.show();

      // update bulk order form is the form is present
      if (document.querySelector('#bulk-table')) {
        bulkOrder.init(false);
      }
    });
  },

  showBulkRates: (productId) => {
    const modalTitle = cartSummary.bulkRateModal.querySelector('.product-name');
    const bulkRateInfoDisplay = cartSummary.bulkRateModal.querySelector('.bulk-rate-info');

    // if there is a coupon in the cart display the discount message
    const localCart = cart.getLocalCart();
    const isCouponApplied = localCart?.cartProducts?.some((product) => product?.discountSource === 'Coupon');
    const product = localCart.cartProducts.find((product) => product.productId === productId);
    const bulkRates = product?.cartProductBulkTiers || [];

    modalTitle.innerHTML = product.name;
    const discountMsgEl = cartSummary.bulkRateModal.querySelector('.modal-discounts-msg');

    if (bulkRates && bulkRates.length > 0) {
      let bulkRateInfo = '';
      for (let i = 0; i < bulkRates.length; i++) {
        const bulkPrice = cartSummary.formatCurrency(bulkRates[i].discountTierUnitPrice);
        if (i < bulkRates.length - 1) {
          const tier = `${bulkRates[i].minQuantity}-${bulkRates[i + 1].minQuantity - 1}`;
          bulkRateInfo += `Buy ${tier} and get a unit price of ${bulkPrice}<br>`;
        } else {
          const tier = `${bulkRates[i].minQuantity} or more`;
          bulkRateInfo += `Buy ${tier} and get a unit price of ${bulkPrice}`;
        }
      }
      bulkRateInfoDisplay.innerHTML = bulkRateInfo;

      if (isCouponApplied) {
        if (!discountMsgEl) {
          bulkRateInfoDisplay.insertAdjacentHTML(
            'afterend',
            '<p class="modal-discounts-msg small text-muted fst-italic mt-2 mb-0">Other discounts may be applied in the cart</p>'
          );
        }
      } else {
        discountMsgEl && discountMsgEl.remove();
      }
    }
    // if product doesn't have bulk tier pricing, either because it normally doesn't or because of the coupon or group ID
    else {
      bulkRateInfoDisplay.innerHTML = `<em>Contact us to speak to a sales representative for bulk pricing.</em>`;
    }

    cartSummary.bulkModal.show();
    cartSummary.bulkRatesShown = true;
  },

  // helper function to get a proeduct's display price
  getDisplayPrice: (item, isUpsell = false) => {
    let amount;
    // if there is a fee
    if (item.unitThirdPartyFee > 0) {
      if (item.hiddenFee) {
        if (item.combinedDiscount > 0) {
          amount = item.unitPriceWithDiscountAndFeeIfHidden;
        } else {
          amount = item.unitPriceWithUnitFeeIfHidden;
        }
      } else {
        if (item.combinedDiscount > 0) {
          if (isUpsell) {
            amount = item.unitPriceAndFee - item.combinedDiscount;
          } else {
            amount = item.listPrice - item.combinedDiscount;
          }
        } else {
          if (isUpsell) {
            amount = item.unitPriceAndFee;
          } else {
            amount = item.listPrice;
          }
        }
      }
    }
    // if there's no fees
    else {
      if (item.combinedDiscount > 0) {
        amount = item.listPrice - item.combinedDiscount;
      } else {
        amount = item.listPrice;
      }
    }
    return amount;
  },

  // helper function to format a number as currency
  formatCurrency: (number) => {
    const price = Number(number);
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
  },
};

// initialize the cart widget
cartSummary.init();

// temporarily always showing the cart widget for development purposes
// cartSummary.show();

// event listeners for showing and hiding the cart widget
(() => {
  // showing the cart widget by clicking the cart icon
  document.addEventListener('click', (e) => {
    const viewCartWidgetBtn = e.target.closest('.show-cart-widget, .cta-btn.view-cart-btn');
    // Check if the clicked element has the class "hide-cart-widget"
    if (viewCartWidgetBtn) {
      e.preventDefault();
      // call toggle function
      cartSummary.show();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const viewCartWidgetBtn = e.target.closest('.show-cart-widget, .cta-btn.view-cart-btn');
      if (viewCartWidgetBtn) {
        if (e.key === ' ') {
          e.preventDefault();
        }
        cartSummary.show();
      }
    }
  });

  // closing the cart widget by clicking the close button or continue shopping button
  document.addEventListener('click', (e) => {
    const hideCartWidgetBtn = e.target.closest('.hide-cart-widget');
    const viewCartWidgetBtn = e.target.closest('.show-cart-widget, .cta-btn.view-cart-btn');
    const cartWidgetEl = e.target.closest('.cart-widget');
    // hidding modal when close button is clicked or if click happens outside the cart widget
    if (hideCartWidgetBtn || (!viewCartWidgetBtn && !cartWidgetEl && !cartSummary.bulkRatesShown)) {
      // call toggle function
      cartSummary.hide();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const hideCartWidgetBtn = e.target.closest('.hide-cart-widget');
      if (hideCartWidgetBtn) {
        if (e.key === ' ') {
          e.preventDefault();
        }
        cartSummary.hide();
      }
    }
  });
})();
